module.exports = __webpack_public_path__ + "media/images/price_list/reference-4-be6767097a3c34c844532140787da4f2.webp";